import { __decorate } from "tslib";
import { Component, Prop, Watch } from "vue-property-decorator";
import SimpleTable from "@/components/SimpleTable.vue";
import { mapActions, mapState } from "vuex";
import ModalMixin from "@/mixins/modal-mixin";
let Index = class Index extends ModalMixin {
    user;
    branchesId;
    dates;
    areReportsLoading;
    perPage = 50;
    currentPage = 1;
    totalRows = 0;
    data = [];
    fetchReports;
    get columns() {
        return [
            {
                label: 'Date',
                name: 'date',
                field: (item) => {
                    return item.date;
                },
                duration: true
            },
            {
                label: 'Customer',
                name: 'customer',
                field: (item) => {
                    if (!item.customer)
                        return '';
                    return `${item.customer.first_name} ${item.customer.last_name}`;
                }
            },
            {
                label: 'Team member',
                name: 'user',
                field: (item) => {
                    if (!item.user)
                        return '';
                    return `${item.user.firstName} ${item.user.lastName}`;
                }
            },
            {
                label: 'Amount',
                name: 'amount',
                money: true,
                field: (item) => item.amount,
                click: (item) => {
                    if (this.$hasPermission('payment-history', ['seeAll']))
                        this.invoiceModal(item.invoiceId);
                }
            },
            {
                label: 'Payment method',
                name: 'paymentMethod',
                field: (item) => {
                    return item.paymentMethods.map((el) => this.$t(el)).join(", ");
                }
            }
        ];
    }
    get query() {
        const query = {
            $limit: this.perPage,
            $skip: (this.currentPage - 1) * this.perPage,
            $sort: {
                date: -1
            }
        };
        if (this.dates.start) {
            query.date = {
                $gte: this.dates.start,
                $lte: this.dates.end
            };
        }
        if (this.branchesId.length > 0)
            query.branchesId = this.branchesId;
        if (this.user.length > 0)
            query.userId = { $in: this.user };
        return query;
    }
    mounted() {
        this.fetchReportsWrapper();
    }
    queryWatcher() {
        this.fetchReportsWrapper();
    }
    fetchReportsWrapper() {
        this.fetchReports({ query: this.query }).then((data) => {
            this.data = data.data;
            this.totalRows = data.total;
        });
    }
};
__decorate([
    Prop({ type: Array })
], Index.prototype, "user", void 0);
__decorate([
    Prop({ type: Array })
], Index.prototype, "branchesId", void 0);
__decorate([
    Prop({ type: Object })
], Index.prototype, "dates", void 0);
__decorate([
    Watch('query')
], Index.prototype, "queryWatcher", null);
Index = __decorate([
    Component({
        components: { SimpleTable },
        methods: {
            ...mapActions('payment-history', { fetchReports: 'find' })
        },
        computed: {
            ...mapState('payment-history', { areReportsLoading: 'isFindPending' })
        }
    })
], Index);
export default Index;
